<template>
  <div>
    <v-alert dense text type="info" color="info">
      {{ $t('common.documentTip') }}
    </v-alert>

    <info-field class="mb-3" v-if="gDriveLink">
      <i18n path="common.ifErrorWhenUploading.message">
        <a :href="gDriveLink" target="_blank">{{ $t('common.ifErrorWhenUploading.folder') }}</a>
      </i18n>
    </info-field>
  </div>
</template>

<script>
import InfoField from '@/components/fields/InfoField.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'TipForDocuments',
  components: {
    InfoField,
  },
  computed: {
    ...mapGetters('candidate', ['gDriveLink']),
  },
};
</script>
